/**
 * Component: Modals
 * Description:
 *
 * Usage:
 *   - Automatically initialises on page load.
 */

export function modals(elements) {
  if (!elements || !elements.length) return;

  elements.forEach(overlay => {
    const dialog = overlay.querySelector('.dialog-overlay__content');
    const closeBtn = overlay.querySelector('.dialog-close');
    const modalId = overlay.id;

    if (!dialog || !modalId) return;

    let lastFocusedElement = null;
    let isAnimating = false;

    const openTriggers = document.querySelectorAll(
      `[data-modal-open="${modalId}"]`
    );

    function openModal() {
        if (isAnimating) return;

        lastFocusedElement = document.activeElement;
        isAnimating = true;

        overlay.classList.add('is-active');

        requestAnimationFrame(() => {
            overlay.classList.add('is-open');
            overlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('dialog-open');

            dialog.focus();
            window.dispatchEvent(new Event('resize'));
            isAnimating = false;
        });
    }

    function closeModal() {
        if (isAnimating) return;

        isAnimating = true;

        // Start animation
        overlay.classList.remove('is-open');

        const onTransitionEnd = e => {
            if (e.target !== dialog) return;

            overlay.classList.remove('is-active');
            overlay.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('dialog-open');

            if (lastFocusedElement) {
            lastFocusedElement.focus();
            }

            dialog.removeEventListener('transitionend', onTransitionEnd);
            isAnimating = false;
        };

        dialog.addEventListener('transitionend', onTransitionEnd);
    }

    // Open triggers
    openTriggers.forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        openModal();
      });
    });

    // Close button
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    // Backdrop click
    overlay.addEventListener('click', e => {
      if (e.target === overlay) {
        closeModal();
      }
    });

    // ESC key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeModal();
      }
    });
  });
}
